var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{ref:"upload",attrs:{"action":_vm.action,"auto-upload":true,"headers":_vm.headers,"show-file-list":false,"on-success":_vm.handleSuccess}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }